module.exports = __webpack_public_path__ + "img/selected3-min.e7c49a4c.png";